import { useSelector } from "react-redux";
import { SupplierList } from "./pages/SupplierList";
import { SupplierCompanyInfo } from "./pages/SupplierCompanyInfo";

export const SupplierDiversity = () => {
  const authUser = useSelector((x) => x.auth?.value);
  const user = authUser?.Data;
  const userAccess = user?.UserAccess;
  const isAdmin = userAccess?.some((access) =>
    access.Role.toLowerCase().includes("admin")
  );

  return isAdmin ? <SupplierList /> : <SupplierCompanyInfo isAdmin={isAdmin} />;
};
